// This component has the buttons used in window function
import React from "react";
import { Button } from "@mui/material";
import { palette } from "../../../.."; // Adjust the import path as necessary

interface WindowFunctionButtonsProps {
  onRemove: () => void;
  onSave: () => void;
}

const WindowFunctionButtons: React.FC<WindowFunctionButtonsProps> = ({
  onRemove,
  onSave,
}) => {
  return (
    <div className="cancelOkBtn" style={{
      marginBlock:'16.5px'
    }}>
      <div
        className="cancelBtn"
        style={{
          display: "flex",
          flexDirection: "row",
          columnGap: "0.2rem",
          justifyContent: "space-between",
          width: "80%",
          marginLeft: "18px",
          marginTop: "10px",
        }}
      >
        <Button
          variant="outlined"
          color="inherit"
          size="small"
          sx={{
            fontSize: "10px",
            boxShadow: "none",
            border: "2px solid gray",
            color: "gray",
            borderRadius: "2px",
            textTransform: "initial",
            "&:hover": {
              color: "white",
              backgroundColor: "red",
              border: "2px solid red",
              boxShadow: "0px 0px 2px 1px red",
            },
          }}
          onClick={onRemove}
        >
          Remove
        </Button>

        <Button
          variant="outlined"
          color="inherit"
          size="small"
          onClick={onSave}
          sx={{
            fontSize: "10px",
            boxShadow: "none",
            border: `2px solid ${palette.primary.main}`,
            borderRadius: "1px",
            textTransform: "initial",
            color: palette.primary.main,
            "&:hover": {
              color: "white",
              backgroundColor: palette.primary.main,
              boxShadow: `0px 0px 2px 1px ${palette.primary.main}`,
            },
          }}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default WindowFunctionButtons;